import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Paper from '@mui/material/Paper';
import { Link, Redirect, Route, Switch, useLocation } from 'react-router-dom';
import { CallHistory } from '../modules/History/Call';
import { SmsHistory } from '../modules/History/Sms';
import { ThreadedSms } from '../components/sms/ThreadedSms';

const useStyles = makeStyles((theme) => ({
  tabs: {
    borderBottom:
      theme.palette.mode === 'dark' ? '1px solid #515151' : '1px solid #e0e0e0',
    indicator: {
      backgroundColor: '#0098C7',
    },
  },
  tab: {
    textTransform: 'none',
    minWidth: 72,
    fontWeight: theme.typography.fontWeightRegular,
    marginRight: theme.spacing(4),
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    '&:hover': {
      color: '#40a9ff',
      opacity: 1,
    },
    '&[aria-selected=true]': {
      color: '#0098C7',
      fontWeight: theme.typography.fontWeightMedium,
    },
  },
  paper: {
    flexGrow: 1,
  },
}));

export function HistoryTabs({ basePath = '/history' }) {
  const classes = useStyles();
  const location = useLocation();
  const pages = {
    callHistory: {
      pathname: `${basePath}/call-history`,
    },
    smsHistory: {
      pathname: `${basePath}/sms-history`,
    },
  };

  return (
    <Paper className={classes.root}>
      {location.pathname !== basePath &&
        location.pathname !== `${basePath}/` && ( // on initial load prevent render since basePath tab undefined
          <Tabs
            className={classes.tabs}
            value={location.pathname.split('/threaded-sms/')[0]} // ignore after /threaded-sms/
            indicatorColor="primary"
            textColor="primary"
            centered
          >
            <Tab
              className={classes.tab}
              label="Call History"
              component={Link}
              value={pages.callHistory.pathname}
              to={{
                pathname: pages.callHistory.pathname,
                search: location.search,
              }}
            />
            <Tab
              className={classes.tab}
              label="SMS History"
              component={Link}
              value={pages.smsHistory.pathname}
              to={{
                pathname: pages.smsHistory.pathname,
                search: location.search,
              }}
            />
          </Tabs>
        )}
      <Switch>
        <Route path="/history/call-history/threaded-sms/:userid/:outsidenumber">
          {({ history, match }) => (
            <ThreadedSms
              show={match != null}
              onHide={() => {
                history.push('/history/call-history');
              }}
              userid={match?.params.userid}
              outsidenumber={match?.params.outsidenumber}
            />
          )}
        </Route>
        <Route path="/history/sms-history/threaded-sms/:userid/:outsidenumber">
          {({ history, match }) => (
            <ThreadedSms
              show={match != null}
              onHide={() => {
                history.push('/history/sms-history');
              }}
              userid={match?.params.userid}
              outsidenumber={match?.params.outsidenumber}
            />
          )}
        </Route>
      </Switch>
      <Switch>
        <Redirect
          exact
          from={basePath}
          to={{
            pathname: pages.callHistory.pathname,
            search: location.search,
          }}
        />
        <Route
          path={pages.callHistory.pathname}
          render={(props) => <CallHistory agentId={null} />}
        />
        <Route
          path={pages.smsHistory.pathname}
          render={(props) => <SmsHistory agentId={null} />}
        />
      </Switch>
    </Paper>
  );
}
